import { get } from 'lodash/fp';
import axios from 'axios';
import Cookies from 'js-cookie';
import withCancellation from '../withCancellation';
import { sites } from '../../helpers/globalVariables';
import config from '../../helpers/config';
import getFuncBySite from '../../utils/getFuncBySite';

import requireLogin from '../../services/requireLogin';

const siteMap = {
  3: 'BDC',
  11: 'THD',
};

const instance = axios.create({
  baseURL: `${config.newMandiBaseUrl}/api`,
});

const getAuthHeader = () => {
  const cec = Cookies.get('internalUserToken');

  try {
    if (cec) {
      const payload64 = cec.split('.')[1];
      const payload = JSON.parse(atob(payload64));

      return `CEC ${payload.username}`;
    }
    // eslint-disable-next-line no-empty
  } catch (_) {}

  return `USER ${get('THDCustomer.default.email', window)}`;
};

const getSiteConfig = getFuncBySite({
  [sites.theHomeDepot]: () => ({ headers: { Authorization: getAuthHeader() } }),
  [sites.blinds]: () => ({ withCredentials: true }),
});

instance.interceptors.request.use(requestConfig => ({
  ...requestConfig,
  params: {
    ...requestConfig.params,
    siteCode: siteMap[get('globalConfig.siteId')(window)],
  },
  ...getSiteConfig(),
}));

instance.interceptors.response.use((response) => {
  if (response.status === 401 || response.status === 403) {
    requireLogin();

    return Promise.reject(response);
  }

  return Promise.resolve(response);
});
export default withCancellation(instance);
